import type { SortOptions } from "@amzn/ads-blink-client";
import { PhoenixMetrics } from "@amzn/ads-phoenix-type-script-client";
import { Dropdown, DropdownItem } from "@amzn/storm-ui";
import { useStore } from "zustand";

import { SortDropdownItems } from "../../../config/filters/unified";
import { LABELS } from "../../../constants/common";
import { TELEMETRY_ID, PHOENIX_FEATURE } from "../../../constants/telemetry";
import { unifiedFilterStore } from "../../../store/unifiedFilters";
import { logWithTakt } from "../../../utils/telemetry.utils";

export const UnifiedSearchSortDropdown: React.FunctionComponent = () => {
    const [sortAttribute, setSortAttribute, setIsContentDirty] = useStore(
        unifiedFilterStore,
        (state) => [
            state.sortAttribute,
            state.setSortAttribute,
            state.setIsContentDirty,
        ],
    );

    const onChange = (event: SortOptions) => {
        setSortAttribute(event);
        setIsContentDirty(true);

        logWithTakt(TELEMETRY_ID.UNIFIED_SEARCH_SORT_SELECTION, {
            selectedSortOption: event,
            previousSortOption: sortAttribute,
        });
        PhoenixMetrics.emit(
            TELEMETRY_ID.UNIFIED_SEARCH_SORT_SELECTION,
            PHOENIX_FEATURE.DISCOVERY,
            {
                customData: {
                    selectedSortOption: event,
                    previousSortOption: sortAttribute,
                },
            },
        );
    };

    return (
        <Dropdown
            selectedValue={sortAttribute}
            label={LABELS.SORT_BY}
            inline={true}
            onChange={(event) => onChange(event)}
            data-testid="search-sort-dropdown"
        >
            {SortDropdownItems.map((item) => {
                return (
                    <DropdownItem key={item.value} value={item.value}>
                        {item.label}
                    </DropdownItem>
                );
            })}
        </Dropdown>
    );
};
